var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as cn from "classnames";
import * as React from "react";
import Panel from "../../../../shared/components/panel";
import AvailabilityFetcher from "./availabilityFetcher";
import BookingActivity from "./bookingActivity";
import BookingButton from "./bookingButton";
import BookingLodging from "./bookingLodging";
import BookingPrice from "./bookingPrice";
import BookingProvider from "./bookingProvider";
import BookingRating from "./bookingRating";
import * as styles from "./styles.css";
var Booking = /** @class */ (function (_super) {
    __extends(Booking, _super);
    function Booking() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Booking.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className;
        return (React.createElement(Panel, { className: cn(styles.booking, className) }, children));
    };
    Booking.Activity = BookingActivity;
    Booking.Button = BookingButton;
    Booking.Lodging = BookingLodging;
    Booking.Price = BookingPrice;
    Booking.Provider = BookingProvider;
    Booking.Rating = BookingRating;
    Booking.AvailabilityFetcher = AvailabilityFetcher;
    return Booking;
}(React.Component));
export default Booking;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/booking/booking.tsx
// module id = P8bB
// module chunks = 2